import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import Divider from "@material-ui/core/Divider";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";

const useStyles = makeStyles(theme => ({
  root: {
    width: 250
  },
  container: {
    padding: "2px 4px 0px 4px",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between"
  },
  input: {
    marginLeft: theme.spacing(1)
  },
  iconButton: {},
  divider: {
    margin: 1
  }
}));

export default function SearchInput({ value, onChange }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <SearchIcon />

        <InputBase
          className={classes.input}
          placeholder="Search"
          inputProps={{ "aria-label": "search" }}
          value={value}
          onChange={event => onChange(event.target.value)}
        />

        <CloseIcon onClick={_ => onChange("")} />
      </div>
      <Divider className={classes.divider} />
    </div>
  );
}
